import createClient, {} from 'openapi-fetch';
export function createApiClient(options) {
    const client = createClient({ baseUrl: options.baseUrl });
    if (options.token) {
        client.use({
            async onRequest({ request }) {
                const token = await options.token();
                if (token)
                    request.headers.set('Authorization', `Bearer ${token}`);
                return request;
            },
        });
    }
    return client;
}
export function isProblemDetails(value) {
    return (typeof value === 'object' &&
        value !== null &&
        typeof value.type === 'string' &&
        typeof value.status === 'number');
}
/** The problem types the client is expected to branch on. */
export const PROBLEM = {
    unauthenticated: 'urn:avenue:problem:unauthenticated',
    forbidden: 'urn:avenue:problem:forbidden',
    unprovisionedIdentity: 'urn:avenue:problem:unprovisioned-identity',
    mfaRequired: 'urn:avenue:problem:mfa-required',
    identityProviderUnavailable: 'urn:avenue:problem:identity-provider-unavailable',
};
//# sourceMappingURL=index.js.map